import type { ThemeMeta, ThemeTokens } from '@/previewThemes/meta';

/**
 * The base theme's tokens, and therefore every theme's starting point.
 *
 * Calibrated to render the storefront exactly as it did before themes were
 * packages: 72rem is Tailwind's max-w-6xl, and a space scale of 1 is today's
 * spacing untouched. Changing a value here changes every theme that inherits
 * it, which is the point and also the reason to leave it alone.
 */
export const tokens: ThemeTokens = {
  headingFont: null,
  accent: null,
  monoFont: null,
  headingTracking: '-0.01em',
  headingTransform: 'none',
  containerMax: '72rem',
  spaceScale: 1,
  headerHeight: '4rem',
};

export const meta: ThemeMeta = {
  label: 'Classic',
  hint: 'Balanced and familiar - the standard shop layout.',
  industries: ['general'],
  look: {
    // The platform's own palette, and the one every other theme is a
    // departure from: white ground, a confident green, near-black text.
    colors: {
      primary: '#16a34a',
      background: '#ffffff',
      surface: '#f8fafc',
      text: '#0b1220',
      muted: '#5b6472',
    },
    typography: { font_family: 'Inter', heading_weight: '700' },
    buttons: { radius_px: 12, style: 'solid' },
    catalog: 'general',
  },
};
